/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Launcher_DescInputs */

const en_fc_dl_launcher_desc = /** @type {(inputs: Fc_Dl_Launcher_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The official launcher installs FilmCraft and keeps it updated, along with the other Crafting Apps.`)
};

/**
* | output |
* | --- |
* | "The official launcher installs FilmCraft and keeps it updated, along with the other Crafting Apps." |
*
* @param {Fc_Dl_Launcher_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_launcher_desc = /** @type {((inputs?: Fc_Dl_Launcher_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Launcher_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_launcher_desc(inputs)
});
export { fc_dl_launcher_desc as "fc.dl.launcher.desc" }